module.exports = __webpack_public_path__ + "img/public/siteImages/user.svg?f1badef2";